import { useEffect, useState } from "react";
import { useParams } from "react-router";
import React from 'react';
import Api from "../../Api/Api";
import { username } from "../../API";

import NavBar from "../Navbar";
import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

const Contact = (userData) => {
  const [user, setUser] = useState(null);
  const [address, setAddress] = useState(null);
  // const { username } = useParams();
  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getUserAbout(username);
      setUser(data);
    };
    getData();
  }, [username]);

  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getUserAddress(username);
      console.log(data);
      setAddress(data);
    };
    getData();
  }, [username]);

  console.log(user)
  return (
    <>
      <NavBar />
      {user && (
        <div>
          <div className="container bg-light rounded mt-5 mb-3 min-vh-100">
            <hr />
            {(user.websiteLink !== "" ||
              user.facebookLink !== "" ||
              user.twitterLink !== "" ||
              user.linkedinLink !== "") && (
                <div className="mt-3 ms-3 ">
                  <h2 className="text-center">Contact Us</h2>
                  {address?.company_name && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Company Name</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}>{address.company_name}</Col>
                    </Row>
                  )}
                  {address?.AdminAddress && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Address</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}>{address.AdminAddress}</Col>
                    </Row>
                  )}
                  {address?.city && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">City</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}>{address.city}</Col>
                    </Row>
                  )}
                  {address?.state && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">State</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}>{address.state}</Col>
                    </Row>
                  )}
                  {user.websiteLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Website</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to={user.websiteLink}>{user.websiteLink}</Link></Col>
                    </Row>
                  )}
                  {user.facebookLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Facebook</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.facebookLink}</Link></Col>
                    </Row>
                  )}
                  {user.twitterLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Twitter</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.twitterLink}</Link></Col>
                    </Row>
                  )}{" "}
                  {user.linkedinLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Linkedin</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.linkedinLink}</Link></Col>
                    </Row>
                  )}
                </div>
              )}
            {/* {(user.websiteLink !== "" ||
              user.facebookLink !== "" ||
              user.twitterLink !== "" ||
              user.linkedinLink !== "") && (
                <div className="mt-3 ms-3">
                  <hr />
                  <h1>Social Links</h1>
                  {user.websiteLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Website</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.websiteLink}</Link></Col>
                    </Row>
                  )}
                  {user.facebookLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Facebook</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.facebookLink}</Link></Col>
                    </Row>
                  )}
                  {user.twitterLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Twitter</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.twitterLink}</Link></Col>
                    </Row>
                  )}{" "}
                  {user.linkedinLink && (
                    <Row className>
                      <Col md={{ offset: 2, span: 2 }}>
                        <p className="text-dark">Linkedin</p>
                      </Col>
                      <Col md={{ offset: 1, span: 7 }}><Link to="#" onClick={() => { window.open(user.facebookLink); }}>{user.linkedinLink}</Link></Col>
                    </Row>
                  )}
                </div>
              )} */}
            {user.featured.length > 0 && (
              <div className="mt-3 ms-3">
                <hr />
                {user.featured.map((featur, index) => (
                  <Card item sm={12} md={2} key={index}>
                    <img alt="" src={featur.url} width="187px" height="181px" />
                  </Card>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default Contact;
